
import React from 'react';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

interface BillSearchProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

const BillSearch = ({ searchTerm, setSearchTerm }: BillSearchProps) => {
  return (
    <div className="relative">
      <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-400" />
      <Input
        placeholder="Search bills..."
        className="pl-8 h-9 w-[200px] bg-background"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  );
};

export default BillSearch;
